<template>
  <v-app id="inspire">
    <Header type="search"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10" v-if="lesson && specialist && room">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">{{ lesson.lesson.type === 1 ? 'Групповое занятие' : 'Персональное занятие'}}</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Расписание /</span> {{ lesson.lesson.type === 1 ? 'Групповое занятие' : 'Персональное занятие' }}</div>
                </div>
                <div>
                  <v-btn
                      color="#629F33"
                      class="button__success"
                      @click="updateLesson(false)"
                  >
                    Сохранить изменения
                  </v-btn>
                </div>
              </v-col>
              <v-col
                v-if="lesson.lesson.status === 2 && lesson.lesson.cancel_reason.name"
                cols="12"
              >
                <v-alert
                    color="red"
                    type="error"
                >
                  Отменено по причине: {{ lesson.lesson.cancel_reason.name }}
                </v-alert>
              </v-col>
              <v-col cols="12">
                <v-sheet class="rounded-lg card">
                  <v-menu
                      top
                      right
                      offset-y
                      rounded="lg"
                      content-class="custom__menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          class="button__lighten ml-3"
                          v-bind="attrs"
                          v-on="on"
                      >
                        <img src="/playground_assets/printer-logo.svg" class="mr-1" alt="">
                        Печать
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item>
                        <v-list-item-title style="cursor: pointer">Акт о выполненных работах</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title style="cursor: pointer">Реестр посещения</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-row style="padding: 20px 20px 0 20px">
                    <v-col
                        md="5"
                    >
                      <label>Услуга</label>
                      <v-select
                          v-model="lesson.lesson.service.name"
                          class="rounded-lg custom__select"
                          :items="[lesson.lesson.service.name]"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          label="Выбрать"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          readonly
                          style="height: 48px;margin-top: 10px"
                      ></v-select>
                    </v-col>
                    <v-col
                        md="5"
                    >
                      <label>Сотрудник</label>
                      <v-select
                          class="rounded-lg custom__select"
                          :value="lesson.lesson.specialist.id"
                          :items="specialist.specialist"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          label="Выбрать"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          readonly
                          style="height: 48px;margin-top: 10px"
                      >
                        <template v-slot:prepend-inner>
                          <div class="logo-bg mr-2">
                            <img src="/playground_assets/users.svg" alt="">
                          </div>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col
                        md="2"
                    >
                      <label>Помещение</label>
                      <v-select
                          :value="lesson.lesson.room.id"
                          class="rounded-lg custom__select"
                          :items="room.room"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          label="Выбрать"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          readonly
                          style="height: 48px;margin-top: 10px"
                      ></v-select>
                    </v-col>
                    <v-col
                      md="3"
                    >
                      <label>Дата</label>
                      <template>
                        <VueDatePicker
                            no-title
                            no-header
                            color="#629f34"
                            v-model="lesson.lesson.date"
                            placeholder="Дата"
                            disabled
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__datepicker"
                                ref="activator"
                                type="button"
                            >
                              <div>
                                <span v-if="date">{{ date }}</span>
                                <span v-else style="color: gray">Дата</span>
                              </div>
                              <div>
                                <v-icon
                                    medium
                                    right
                                    class="ml-5"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                              </div>
                            </button>
                          </template>
                        </VueDatePicker>
                      </template>
                    </v-col>
                    <v-col
                        md="3"
                    >
                      <label>Начало</label>
                      <v-select
                          :value="lesson.lesson.startdate"
                          class="rounded-lg custom__select"
                          :items="start_time"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          color="#629F33"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          required
                          readonly
                          style="height: 48px;margin-top: 10px"
                      >
                      </v-select>
                    </v-col>
                    <v-col
                        md="3"
                    >
                      <label>Продолжительность</label>
                      <v-text-field
                          class="rounded-lg"
                          outlined
                          dense
                          required
                          :value="lesson.lesson.duration + ' мин'"
                          readonly
                          style="height: 48px;margin-top: 10px"
                      >
<!--                        <template v-slot:append>-->
<!--                          <v-btn-toggle style="margin-right: -12px" class="rounded-r-lg no-active__toggle">-->
<!--                            <v-btn @click="downDuration" style="padding: 0 !important; min-width: 38px !important; margin-top: -8px;">-->
<!--                              <v-icon>mdi-chevron-down</v-icon>-->
<!--                            </v-btn>-->
<!--                            <v-btn @click="upDuration" style="padding: 0 !important; min-width: 38px !important; margin-top: -8px;">-->
<!--                              <v-icon>mdi-chevron-up</v-icon>-->
<!--                            </v-btn>-->
<!--                          </v-btn-toggle>-->
<!--                        </template>-->
                      </v-text-field>
                    </v-col>
                    <v-col
                      md="3"
                    >
                      <v-btn-toggle
                          :value="lesson.lesson.duration === 60 ? 1 : 0"
                          mandatory
                          class="rounded-lg"
                          style="margin-top: 33px;"
                      >
                        <v-btn disabled style="background-color: #FFF !important;" @click="lesson.lesson.duration = 30">
                          30 мин
                        </v-btn>
                        <v-btn disabled style="background-color: #FFF !important;" @click="lesson.lesson.duration = 60">
                          60 мин
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                    <v-col
                        md="3"
                        v-if="lesson.lesson.type === 1"
                    >
                      <label>Емкость</label>
                      <v-text-field
                          class="rounded-lg"
                          outlined
                          dense
                          required
                          v-model="lesson.lesson.capacity"
                          readonly
                          style="height: 48px;margin-top: 10px"
                      >
<!--                        <template v-slot:append>-->
<!--                          <v-btn-toggle style="margin-right: -12px" class="rounded-r-lg no-active__toggle">-->
<!--                            <v-btn @click="downCapacity" style="padding: 0 !important; min-width: 38px !important; margin-top: -8px;">-->
<!--                              <v-icon>mdi-chevron-down</v-icon>-->
<!--                            </v-btn>-->
<!--                            <v-btn @click="upCapacity" style="padding: 0 !important; min-width: 38px !important; margin-top: -8px;">-->
<!--                              <v-icon>mdi-chevron-up</v-icon>-->
<!--                            </v-btn>-->
<!--                          </v-btn-toggle>-->
<!--                        </template>-->
                      </v-text-field>
                    </v-col>
                    <v-col md="9" v-if="lesson.lesson.type === 1"></v-col>
                    <v-col md="5">
                      <v-btn-toggle
                          v-model="lesson.lesson.status"
                          mandatory
                          class="rounded-lg"
                          style="margin-top: 35px;"
                      >
                        <v-btn style="padding: 12px 20px !important; background-color: #fff !important;">
                          Запланировано
                        </v-btn>
                        <v-btn style="padding: 12px 20px !important; background-color: #fff !important;">
                          Выполнено
                        </v-btn>
                        <v-btn v-if="lesson.lesson.type === 0" style="padding: 12px 20px !important; background-color: #fff !important;" @click="dialogCancelLesson">
                          Отменено
                        </v-btn>
                        <v-btn v-else style="padding: 12px 20px !important; background-color: #fff !important;">
                          Отменено
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                    <v-col md="1" v-if="lesson.lesson.type === 1"></v-col>
                    <v-col md="3" v-if="lesson.lesson.type === 1">
                      <label>Клиентов записано</label>
                      <v-text-field
                          v-model="lesson.lesson.recorded"
                          required
                          class="rounded-lg"
                          outlined
                          dense
                          readonly
                          style="height: 40px;margin-top: 10px; background-color: #F1F1F1 !important;"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col md="3" v-if="lesson.lesson.type === 1">
                      <label>Клиентов посетило</label>
                      <v-text-field
                          v-model="lesson.lesson.visited"
                          required
                          class="rounded-lg"
                          outlined
                          dense
                          readonly
                          style="height: 40px;margin-top: 10px; background-color: #F1F1F1 !important;"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <v-data-table
                    v-if="lesson.lesson.type === 0"
                    :headers="headersPersonalLessons"
                    :items="successLessons"
                    no-data-text="Нет записанных клиентов"
                    :hide-default-footer="true"
                >
                  <template v-slot:item.client="{ item }">
                    {{ item.client.name ? item.client.name : (item.client.fio ? item.client.fio : '') }}
                  </template>
                  <template v-slot:item.product="{ item }">
                    {{ item.product.name ? item.product.name : item.product.product }}
                  </template>
                  <template v-slot:item.arrival_status="{ item }">
                    <v-select
                        class="rounded-lg table__select"
                        v-model="item.arrival_status"
                        :items="statusTypes"
                        item-value="type_id"
                        item-text="type_name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        append-icon="mdi-chevron-down"
                        outlined
                        dense
                        required
                        style="height: 48px;margin-top: 10px"
                    >
                    </v-select>
                  </template>
                  <template v-slot:item.action="{ item }" >
                    <v-tooltip
                        top
                        content-class="black tooltip-top"
                    >
                      Отменить
                      <template v-slot:activator="{ on }">
                        <div class="cancel-bg d-flex justify-center align-center" v-on="on" @click="dialogCancelClient(item.client.id)">
                          <v-icon size="16" color="#FFF">mdi-cancel</v-icon>
                        </div>
                      </template>
                    </v-tooltip>
                  </template>
                  <template v-if="lesson.lesson.client_list.length < 1" v-slot:body.append>
                    <tr>
                      <td colspan="1" class="text-start">
                        <v-autocomplete
                            class="rounded-lg table__select"
                            :items="listClient ? listClient.client : []"
                            item-value="client_id"
                            item-text="name"
                            :menu-props="{ top: true, offsetY: true, rounded: 'lg' }"
                            label="Добавить клиента"
                            append-icon="mdi-chevron-down"
                            no-data-text="Результатов не найдено"
                            :search-input.sync="search_client"
                            v-model="select_client"
                            hide-details
                            outlined
                            dense
                            color="#629F33"
                            style="height: 48px;padding-top: 5px;"
                        >
                          <template v-slot:prepend-inner>
                            <div class="logo-bg mr-2">
                              <img src="/playground_assets/users.svg" alt="">
                            </div>
                          </template>
                        </v-autocomplete>
                      </td>
                      <td
                          colspan="1"
                          class="text-start"
                          v-if="reason && select_client && (lesson.lesson.service.available && lesson.lesson.service.available === true) && lesson.lesson.service.price && lesson.lesson.service.price > 0"
                      >
                        <v-select
                            class="rounded-lg table__select"
                            label="Выбрать основание"
                            v-model="select_reason"
                            :items="reason.reason"
                            item-value="id"
                            item-text="name"
                            :menu-props="{ top: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            style="height: 48px;margin-top: 10px"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content v-if="(lesson.lesson.service.available && lesson.lesson.service.available === true) && lesson.lesson.service.price && lesson.lesson.service.price > 0" @click="dialogCreateSale = true" style="cursor: pointer">
                                <v-list-item-title class="sale-service_text">
                                  <span>Продать услугу: <span style="color: #000"> {{ lesson.lesson.service.name }} -</span> {{ lesson.lesson.service.price }} ₽ ({{ lesson.lesson.service.price_type.name }})</span>
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-content v-else style="cursor: pointer">
                                <v-list-item-title class="sale-service_text">
                                  <span>Продать услугу: <span style="color: #D53025"> Нет доступных </span></span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>
                      </td>
                      <td v-else>Основание не требуется</td>
                      <td
                                colspan="1"
                                class="text-start"
                                v-if="(lesson.lesson.service.available && lesson.lesson.service.available === true) && lesson.lesson.service.price && lesson.lesson.service.price > 0 && select_reason"
                            >
                              <v-select
                                  class="rounded-lg table__select"
                                  v-model="select_status"
                                  :items="statusTypes"
                                  item-value="type_id"
                                  item-text="type_name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              >
                              </v-select>
                            </td>
                            <td
                                colspan="1"
                                class="text-start"
                                v-else-if="(!lesson.lesson.service.available || lesson.lesson.service.available === false) && (!lesson.lesson.service.price || lesson.lesson.service.price === 0) "
                            >
                              <v-select
                                  class="rounded-lg table__select"
                                  v-model="select_status"
                                  :items="statusTypes"
                                  item-value="type_id"
                                  item-text="type_name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              >
                              </v-select>
                            </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-sheet v-if="lesson.lesson.type === 1" class="rounded-lg card" style="padding: 0 !important;">
                  <v-tabs
                      id="horizontal_tabs"
                      v-model="lesson_tab"
                      style="padding: 20px"
                  >
                    <v-tab
                        v-for="item in lessons"
                        :key="item.tab"
                        class="ml-4"
                    >
                      {{ item.tab }}
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="lesson_tab">
                    <v-tab-item>
                      <v-data-table
                        :headers="headersSuccessLessons"
                        :items="successLessons"
                        no-data-text="Нет записанных клиентов"
                        :hide-default-footer="true"
                              disable-pagination
                      >
                      <template v-slot:item.client="{ item }">
                        {{ item.client.name ? item.client.name : (item.client.fio ? item.client.fio : '') }}
                      </template>
                        <template v-slot:item.product="{ item }">
                          {{ item.product.name ? item.product.name : item.product.product }}
                        </template>
                        <template v-slot:item.arrival_status="{ item }">
                          <v-select
                              class="rounded-lg table__select"
                              v-model="item.arrival_status"
                              :items="statusTypes"
                              item-value="type_id"
                              item-text="type_name"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                              append-icon="mdi-chevron-down"
                              outlined
                              dense
                              required
                              style="height: 48px;margin-top: 10px"
       
                          >
                          </v-select>
                        </template>
                        <template v-if="lesson.lesson.type === 1" v-slot:item.action="{ item }">
                          <v-tooltip
                              top
                              content-class="black tooltip-top"
                          >
                            Отменить
                            <template v-slot:activator="{ on }">
                              <div class="cancel-bg d-flex justify-center align-center" v-on="on" @click="dialogCancelClient(item.client.id)">
                                <v-icon size="16" color="#FFF">mdi-cancel</v-icon>
                              </div>
                            </template>
                          </v-tooltip>
                        </template>
                        <template v-slot:body.append>
                          <tr>
                            <td colspan="1" class="text-start">
                              <v-autocomplete
                                  class="rounded-lg table__select"
                                  :items="listClient ? listClient.client : []"
                                  item-value="client_id"
                                  item-text="name"
                                  :menu-props="{ top: true, offsetY: true, rounded: 'lg' }"
                                  label="Добавить клиента"
                                  append-icon="mdi-chevron-down"
                                  no-data-text="Результатов не найдено"
                                  :search-input.sync="search_client"
                                  v-model="select_client"
                                  hide-details
                                  outlined
                                  dense
                                  color="#629F33"
                                  style="height: 48px;padding-top: 5px;"
                              >
                                <template v-slot:prepend-inner>
                                  <div class="logo-bg mr-2">
                                    <img src="/playground_assets/users.svg" alt="">
                                  </div>
                                </template>
                              </v-autocomplete>
                            </td>
                            <td
                              colspan="1"
                              class="text-start"
                              v-if="reason && select_client && (lesson.lesson.service.available && lesson.lesson.service.available === true) && lesson.lesson.service.price && lesson.lesson.service.price > 0"
                            >
                              <v-select
                                  class="rounded-lg table__select"
                                  label="Выбрать основание"
                                  v-model="select_reason"
                                  :items="reason.reason"
                                  item-value="id"
                                  item-text="name"
                                  :menu-props="{ top: true, offsetY: true, rounded: 'lg' }"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              >
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-content v-if="(lesson.lesson.service.available && lesson.lesson.service.available === true) && lesson.lesson.service.price && lesson.lesson.service.price > 0" @click="dialogCreateSale = true" style="cursor: pointer">
                                      <v-list-item-title class="sale-service_text">
                                        <span>Продать услугу: <span style="color: #000"> {{ lesson.lesson.service.name }} -</span> {{ lesson.lesson.service.price }} ₽ ({{ lesson.lesson.service.price_type.name }})</span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-content v-else style="cursor: pointer">
                                      <v-list-item-title class="sale-service_text">
                                        <span>Продать услугу: <span style="color: #D53025"> Нет доступных </span></span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-select>
                            </td>
                            <td v-else>
                              Основание не требуется
                            </td>
                            <td
                                colspan="1"
                                class="text-start"
                                v-if="(lesson.lesson.service.available && lesson.lesson.service.available === true) && lesson.lesson.service.price && lesson.lesson.service.price > 0 && select_reason"
                            >
                              <v-select
                                  class="rounded-lg table__select"
                                  v-model="select_status"
                                  :items="statusTypes"
                                  item-value="type_id"
                                  item-text="type_name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              >
                              </v-select>
                            </td>
                            <td
                                colspan="1"
                                class="text-start"
                                v-else-if="(!lesson.lesson.service.available || lesson.lesson.service.available === false) && (!lesson.lesson.service.price || lesson.lesson.service.price === 0) "
                            >
                              <v-select
                                  class="rounded-lg table__select"
                                  v-model="select_status"
                                  :items="statusTypes"
                                  item-value="type_id"
                                  item-text="type_name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              >
                              </v-select>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                      <v-data-table
                        :headers="headersCancelLessons"
                        :items="cancelLessons"
                        no-data-text="Нет отменённых клиентов"
                        :hide-default-footer="true"
                      >
                      <template v-slot:item.client="{ item }">
                        {{ item.client.name ? item.client.name : (item.client.fio ? item.client.fio : '') }}
                      </template>
                      
                        <template v-slot:item.product="{ item }">
                          {{ item.product.name ? item.product.name : item.product.product }}
                        </template>
                        <template v-slot:item.arrival_status>
                          Отменен
                        </template>
                        <template v-slot:item.cancel_date="{ item }">
                          {{ (new Date(item.cancel_date)).getDate() + ' ' + months[(new Date(item.cancel_date)).getMonth()] + ' ' + (new Date(item.cancel_date)).getHours() + ':' + String((new Date(item.cancel_date)).getMinutes()).padStart(2, "0") }}
                        </template>
                        <template v-slot:item.comment="{ item }">
                          <span v-if="item.comment">{{ item.comment }}</span>
                          <span v-else style="color: #629F33; cursor: pointer" @click="dialogCommentClient(item.client.id)">Оставить комментарий</span>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-tooltip
                              top
                              content-class="black tooltip-top"
                          >
                            Вернуть
                            <template v-slot:activator="{ on }">
                              <div class="return-bg d-flex justify-center align-center" v-on="on" @click="dialogReturnClient(item.client.id)">
                                <v-icon size="16" color="#FFF">mdi-restore</v-icon>
                              </div>
                            </template>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-tab-item>
                  </v-tabs-items>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogCancel"
              persistent
              max-width="600px"
              v-if="cancelReason"
          >
            <v-card>
              <v-card-title class="text-center">
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogCancel = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 30px;">
                <v-container>
                  <div class="text-center">
                    <h3 class="text-center">Выберите причину отмены</h3>
                  </div>
                  <v-form ref="cancelClientForm" v-if="lesson.lesson.type === 0" @submit.prevent="cancelLesson">
                    <v-row
                        align="center"
                        class="mt-5 d-flex flex-column justify-center"
                    >
                      <v-col cols="6" style="padding: 0!important;">
                        <v-select
                            class="rounded-lg custom__select"
                            v-model="select_cancelReason"
                            :items="cancelReason.cancelReason"
                            item-value="id"
                            item-text="name"
                            :rules="[v => !!v || 'Выберите причину отмены']"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            label="Причина"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            color="#629F33"
                            style="height: 48px; "
                        ></v-select>
                      </v-col>
                      <button
                          class="button button__success"
                          ref="activator"
                          type="submit"
                          style="margin:auto; font-weight: 700; margin-top: 30px !important;"
                      >
                        Выбрать
                      </button>
                    </v-row>
                  </v-form>
                  <v-form ref="cancelClientForm" v-else @submit.prevent="updateLesson(true)">
                    <v-row
                        align="center"
                        class="mt-5 d-flex flex-column justify-center"
                    >
                      <v-col cols="6" style="padding: 0!important;">
                        <v-select
                            class="rounded-lg custom__select"
                            v-model="select_cancelReason"
                            :items="cancelReason.cancelReason"
                            item-value="id"
                            item-text="name"
                            :rules="[v => !!v || 'Выберите причину отмены']"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            label="Причина"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            color="#629F33"
                            style="height: 48px; "
                        ></v-select>
                      </v-col>
                      <button
                          class="button button__success"
                          ref="activator"
                          type="submit"
                          style="margin:auto; font-weight: 700; margin-top: 30px !important;"
                      >
                        Выбрать
                      </button>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogComment"
              persistent
              max-width="600px"
          >
            <v-card>
              <v-card-title class="text-center">
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogComment = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 30px;">
                <v-container>
                  <div class="text-center">
                    <h3 class="text-center">Комментарий</h3>
                  </div>
                  <v-form ref="commentClientForm" @submit.prevent="updateLesson(true)">
                    <v-row
                        align="center"
                        class="mt-5 d-flex flex-column justify-center"
                    >
                      <v-col cols="12" style="padding: 0!important;">
                        <v-textarea
                            placeholder="Написать..."
                            v-model="comment"
                            :rules="[v => !!v || 'Напишите комментарий...']"
                            rounded
                            outlined
                            dense
                            required
                            auto-grow
                            background-color="#fff"
                            rows="5"
                            style="height: 135px;"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <div class="text-right mt-4">
                      <button
                          class="button button__success"
                          ref="activator"
                          type="submit"
                          style="margin:auto; font-weight: 700;"
                      >
                        Добавить
                      </button>
                    </div>
                  </v-form>
                </v-container>
              </v-card-text>

            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogCreateSale"
              persistent
              max-width="400px"
          >
            <v-card>
              <v-card-title class="text-center">
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogCreateSale = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 30px;">
                <v-container>
                  <div>
                    <h3 class="card-title">Вы уверены, что хотите создать продажу?</h3>
                  </div>
                  <v-row
                      align="center"
                      class="mt-5 justify-center"
                  >
                    <button
                        class="button button__success"
                        ref="activator"
                        type="button"
                        @click="createSale"
                    >
                      Да
                    </button>
                    <button
                        class="button button__secondary ml-5"
                        ref="activator"
                        type="button"
                        @click="dialogCreateSale = false"
                    >
                      Нет
                    </button>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogReturn"
              persistent
              max-width="400px"
          >
            <v-card>
              <v-card-title class="text-center">
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogReturn = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 30px;">
                <v-container>
                  <div>
                    <h3 class="card-title">Вы уверены, что хотите вернуть клиента к составу занятия?</h3>
                  </div>
                  <v-row
                      align="center"
                      class="mt-5 justify-center"
                  >
                    <button
                        class="button button__success"
                        ref="activator"
                        type="button"
                        @click="updateLesson(true)"
                    >
                      Да
                    </button>
                    <button
                        class="button button__secondary ml-5"
                        ref="activator"
                        type="button"
                        @click="dialogReturn = false"
                    >
                      Нет
                    </button>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {mapState} from "vuex";
import {lessonActionTypes} from "@/store/modules/lesson";
import {clientActionTypes} from '@/store/modules/client';
import {salesActionTypes} from '@/store/modules/sale';
import {getItem, setItem} from "../helpers/persistanceStorage";

export default {
  name: "Lesson",
  props: ['appointment_id'],
  components: {
    VueDatePicker,
    Header,
    Menu
  },
  computed: {
    ...mapState({
      listClient: state => state.client.listClient,
      lesson: state => state.lesson.lesson,
      specialist: state => state.lesson.specialist,
      room: state => state.lesson.room,
      reason: state => state.lesson.reason,
      cancelReason: state => state.lesson.cancelReason
    }),
    successLessons() {
      return this.lesson.lesson.client_list.filter(item => item.arrival_status !== 2);
    },
    cancelLessons() {
      return this.lesson.lesson.client_list.filter(item => item.arrival_status === 2);
    }
  },
  data() {
    return {
      date: null,
      time: 0,
      dialogCancel: false,
      dialogReturn: false,
      dialogComment: false,
      dialogCreateSale: false,
      status: 0,
      statusTypes: [
        {type_id: 0, type_name: 'Не прибыл'},
        {type_id: 1, type_name: 'Прибыл'}
      ],
      search: '',
      search_client: '',
      select_client: null,
      select_reason: null,
      select_cancelReason: null,
      cancelClient: null,
      returnClient: null,
      commentClient: null,
      comment: null,
      select_sale: null,
      select_status: 0,
      toggle_status: null,
      start_time:[
          '07:00','07:05','07:10','07:15','07:20','07:25','07:30','07:35','07:40','07:45','07:50','07:55',
          '08:00','08:05','08:10','08:15','08:20','08:25','08:30','08:35','08:40','08:45','08:50','08:55',
          '09:00','09:05','09:10','09:15','09:20','09:25','09:30','09:35','09:40','09:45','09:50','09:55',
          '10:00','10:05','10:10','10:15','10:20','10:25','10:30','10:35','10:40','10:45','10:50','10:55',
          '11:00','11:05','11:10','11:15','11:20','11:25','11:30','11:35','11:40','11:45','11:50','11:55',
          '12:00','12:05','12:10','12:15','12:20','12:25','12:30','12:35','12:40','12:45','12:50','12:55',
          '13:00','13:05','13:10','13:15','13:20','13:25','13:30','13:35','13:40','13:45','13:50','13:55',
          '14:00','14:05','14:10','14:15','14:20','14:25','14:30','14:35','14:40','14:45','14:50','14:55',
          '15:00','15:05','15:10','15:15','15:20','15:25','15:30','15:35','15:40','15:45','15:50','15:55',
          '16:00','16:05','16:10','16:15','16:20','16:25','16:30','16:35','16:40','16:45','16:50','16:55',
          '17:00','17:05','17:10','17:15','17:20','17:25','17:30','17:35','17:40','17:45','17:50','17:55',
          '18:00','18:05','18:10','18:15','18:20','18:25','18:30','18:35','18:40','18:45','18:50','18:55',
          '19:00','19:05','19:10','19:15','19:20','19:25','19:30','19:35','19:40','19:45','19:50','19:55',
          '20:00','20:05','20:10','20:15','20:20','20:25','20:30','20:35','20:40','20:45','20:50','20:55',
          '21:00','21:05','21:10','21:15','21:20','21:25','21:30','21:35','21:40','21:45','21:50','21:55',
          '22:00','22:05','22:10','22:15','22:20','22:25','22:30','22:35','22:40','22:45','22:50','22:55',
          '23:00'
      ],
      client_list: [],
      lesson_tab: null,
      lessons: [
        {tab: 'Состав занятия'},
        {tab: 'Отменённые клиенты'}
      ],
      headersPersonalLessons: [
        {text: 'Клиент', align: 'start', sortable: false, value: 'client', width: '30%'},
        {text: 'Основание', sortable: false, value: 'product', width: '30%'},
        {text: 'Статус прибытия клиента', sortable: false, value: 'arrival_status', width: '30%'}
      ],
      headersSuccessLessons: [
        {text: 'Клиент', align: 'start', sortable: false, value: 'client', width: '30%'},
        {text: 'Основание', sortable: false, value: 'product', width: '30%'},
        {text: 'Статус прибытия клиента', sortable: false, value: 'arrival_status', width: '30%'},
        {text: 'Действие', value: 'action', sortable: false, width: '5%'}
      ],
      headersCancelLessons: [
        {text: 'Клиент', align: 'start', sortable: false, value: 'client',},
        {text: 'Основание', sortable: false, value: 'product'},
        {text: 'Статус прибытия клиента', sortable: false, value: 'arrival_status'},
        {text: 'Дата и время отмены', sortable: false, value: 'cancel_date', width: '15%'},
        {text: 'Комментарий', sortable: false, value: 'comment', width: '20%'},
        {text: 'Действие', value: 'action', sortable: false, width: '5%'}
      ],
      months: [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря'
      ]
    }
  },
  methods: {
    fetchFeed(appointment_id) {
      this.$store.dispatch(lessonActionTypes.getLessonInfo, { appointment_id });
      this.$store.dispatch(lessonActionTypes.getSpecialistList);
      this.$store.dispatch(lessonActionTypes.getRoomList, {
        for_lesson: true
      });
    },
    downDuration() {
      if (this.lesson.lesson.duration !== 0) {
        this.lesson.lesson.duration--;
      }
    },
    upDuration() {
      if (this.lesson.lesson.duration !== 60) {
        this.lesson.lesson.duration++;
      }
    },
    downCapacity() {
      if (this.lesson.lesson.capacity !== 0) {
        this.lesson.lesson.capacity--;
      }
    },
    upCapacity() {
      if (this.lesson.lesson.capacity !== 10) {
        this.lesson.lesson.capacity++;
      }
    },
    dialogCancelLesson() {
      this.$store.dispatch(lessonActionTypes.getCancelReasonList);
      this.dialogCancel = true;
    },
    dialogCancelClient(client_id) {
      this.$store.dispatch(lessonActionTypes.getCancelReasonList);
      this.cancelClient = client_id;
      this.dialogCancel = true;
    },
    createSale() {
      this.$store.dispatch(salesActionTypes.createSale, {
        client_id: this.select_client,
        service_list: [
          {
            service_id: this.lesson.lesson.service.id,
            name: this.lesson.lesson.service.name,
            price: this.lesson.lesson.service.price,
            count: 1,
            sum: this.lesson.lesson.service.price,
            specialist_id: this.lesson.lesson.specialist.id,
            discount_summ:0,
            discount:0
          }
        ]
      })
          .then(() => {
            this.$store.dispatch(lessonActionTypes.getReasonList, {
              client_id: this.select_client,
              service_id: this.lesson.lesson.service.id
            });
            this.dialogCreateSale = false;
          })
    },
    dialogReturnClient(client_id) {
      this.returnClient = client_id;
      this.dialogReturn = true;
    },
    dialogCommentClient(client_id) {
      this.commentClient = client_id;
      this.dialogComment = true;
    },
    updateLesson(it) {
      for (let client of this.lesson.lesson.client_list) {
        if(this.client_list.indexOf(client.client.id) === -1) {
          this.client_list.push({
            client_id: client.client.id,
            arrival_status: client.arrival_status,
            cancel_reason: client.cancel_reason.id,
            comment: client.comment,
            cancel_date: client.cancel_date,
            product_id: client.product.id
          })
        }
      }
      console.log('bbb44444')
      if(!it) {
        console.log('bbb1')
        if((this.lesson.lesson.service.available && this.lesson.lesson.service.available === true) && this.lesson.lesson.service.price && this.lesson.lesson.service.price > 0) {
          console.log('bbb2')
          if (this.select_client !== null && this.select_reason !== null && this.select_status !== null) {
            console.log('bbb3')
            this.client_list.push({
              client_id: this.select_client,
              arrival_status: this.select_status,
              cancel_reason: "",
              comment: "",
              cancel_date: "0001-01-01T00:00:00",
              product_id: this.select_reason
            })
          }
        } else if(this.select_client !== null && this.select_status !== null) {
          console.log('bbb4')
          this.client_list.push({
              client_id: this.select_client,
              arrival_status: this.select_status,
              cancel_reason: "",
              comment: "",
              cancel_date: "0001-01-01T00:00:00",
              product_id: this.select_reason
            })
        }
      } else {

        console.log('bbb4444455555555555555555')
        if (this.select_client !== null && this.select_reason !== null && this.select_status !== null) {
          this.client_list.push({
            client_id: this.select_client,
            arrival_status: this.select_status,
            cancel_reason: "",
            comment: "",
            cancel_date: "0001-01-01T00:00:00",
            product_id: this.select_reason
          })
        }

      }

      if (this.dialogCancel && this.$refs.cancelClientForm.validate() && this.select_cancelReason !== null) {
        this.client_list.forEach((item, index) => {
          if (item.client_id === this.cancelClient) {
            this.client_list[index].arrival_status = 2;
            this.client_list[index].cancel_reason = this.select_cancelReason;
            this.client_list[index].cancel_date = new Date();
          }
        })
        this.$store.dispatch(lessonActionTypes.updateLesson, {
          appointment_id: this.appointment_id,
          status: this.lesson.lesson.status,
          client_list: this.client_list
        })
            .then(() => {
              this.fetchFeed(this.appointment_id);
              this.select_cancelReason = null;
              this.dialogCancel = false;
            })
      }
      if (this.dialogComment && this.$refs.commentClientForm.validate() && this.comment !== null) {
        this.client_list.forEach((item, index) => {
          if (item.client_id === this.commentClient) {
            this.client_list[index].comment = this.comment;
          }
        })
        this.$store.dispatch(lessonActionTypes.updateLesson, {
          appointment_id: this.appointment_id,
          status: this.lesson.lesson.status,
          client_list: this.client_list
        })
            .then(() => {
              this.fetchFeed(this.appointment_id);
              this.comment = null;
              this.dialogComment = false;
            })
      }
      if (this.dialogReturn) {
        this.client_list.forEach((item, index) => {
          if (item.client_id === this.returnClient) {
            this.client_list[index].arrival_status = 0;
            this.client_list[index].cancel_reason = "";
            this.client_list[index].comment = "";
            this.client_list[index].cancel_date = "0001-01-01T00:00:00";
          }
        })
        this.$store.dispatch(lessonActionTypes.updateLesson, {
          appointment_id: this.appointment_id,
          status: this.lesson.lesson.status,
          client_list: this.client_list
        })
            .then(() => {
              this.fetchFeed(this.appointment_id);
              this.dialogReturn = false;
            })
      }
      if (!this.dialogCancel && !this.dialogReturn && !this.dialogComment) {
        this.$store.dispatch(lessonActionTypes.updateLesson, {
          appointment_id: this.appointment_id,
          status: this.lesson.lesson.status,
          client_list: this.client_list
        })
            .then(() => {
              this.fetchFeed(this.appointment_id);
              this.select_client = null;
              this.select_reason = null;
              this.select_status = null;
            })
      }
    },
    cancelLesson(){
      if (this.$refs.cancelClientForm.validate()) {
        this.$store.dispatch(lessonActionTypes.cancelLesson, {
          appointment_id: this.appointment_id,
          cancel_reason: this.select_cancelReason
        })
            .then(() => {
              this.fetchFeed(this.appointment_id);
              this.dialogCancel = false;
            })
      }
    },
  },
  mounted() {
    this.appointment_id !== undefined ? setItem('schedule-appointment_id', this.appointment_id) : this.appointment_id = getItem('schedule-appointment_id');
    this.fetchFeed(this.appointment_id);
  },
  watch: {
    search_client() {
      if (this.search_client !== '') {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search_client
        })
      }
    },
    select_client() {
      if (this.select_client !== null) {
        this.$store.dispatch(lessonActionTypes.getReasonList, {
          client_id: this.select_client,
          service_id: this.lesson.lesson.service.id
        });
      }
    }
  }
}
</script>

<style scoped>
.logo-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}
.vd-activator .custom__datepicker {
  width: 89% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
}
.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0!important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
  min-width: 64px !important;
}
.cancel-bg {
  background: #D53025 !important;
  border-radius: 12px !important;
  width: 48px !important;
  height: 32px !important;
}
.return-bg {
  background: #629F33 !important;
  border-radius: 12px !important;
  width: 48px !important;
  height: 32px !important;
}
.time-control__button {
  border-left: 1px solid #E0E0E0;
}
.time-active {
  color: #767676 !important;
}
.sale-service_text {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
  display: flex;
  align-items: center;
  color: #767676;
}
.card-title {
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  padding: 0 25px;
}

.custom__menu {
  max-height: 112px !important;
  max-width: 199px !important;
}
.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}
.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}
</style>